import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation } from 'types'

import { rooftopDamageCategories } from './rooftopDamageTypes'
import { StyledDamageSelect } from './StyledDamageSelect'

const RooftopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`

interface RooftopDamageSelectorProps {
  selectedTypes: string[]
  onSelectionChange: (types: string[]) => void
  annotation: KVAnnotation
}

export const RooftopDamageSelector: FC<RooftopDamageSelectorProps> = ({
  selectedTypes,
  onSelectionChange,
  annotation,
}) => {
  const groupedOptions = rooftopDamageCategories.map((category) => ({
    label: category.label,
    options: category.types.map((type) => ({
      label: type.label,
      value: type.id,
    })),
  }))

  const handleChange = (value: unknown) => {
    const selectedArray = Array.isArray(value) ? (value as string[]) : []
    onSelectionChange(selectedArray)
  }

  const handleDropdownVisibleChange = (open: boolean) => {
    if (open) {
      // Reset dropdown scroll position when opening
      requestAnimationFrame(() => {
        const dropdown = document.querySelector(
          '.damage-type-dropdown .rc-virtual-list-holder'
        )
        if (dropdown) {
          dropdown.scrollTop = 0
        }
      })
    }
  }

  const disabled = annotation.historical

  return (
    <RooftopContainer
      onKeyDown={(e) => e.stopPropagation()}
      onKeyUp={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}>
      <StyledDamageSelect
        mode='multiple'
        placeholder='Select damage types...'
        value={selectedTypes}
        onChange={handleChange}
        options={groupedOptions}
        showSearch
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        allowClear
        dropdownStyle={{
          backgroundColor: '#1a1a1a',
          border: '1px solid #666666',
        }}
        popupClassName='damage-type-dropdown'
        disabled={disabled}
        onDropdownVisibleChange={handleDropdownVisibleChange}
      />
    </RooftopContainer>
  )
}
